export function calculateScrollViewerCurrentPage({
  pageHeight,
  wrapperStartY,
  wrapperBottomY,
  currentScrollY,
  currentPageCount,
}: {
  pageHeight: number;
  wrapperStartY: number;
  wrapperBottomY: number;
  currentScrollY: number;
  currentPageCount: number;
}) {
  const roundedScrollY = Math.round(currentScrollY);
  if (roundedScrollY >= wrapperBottomY - pageHeight) {
    return currentPageCount;
  }

  return Math.max(
    Math.floor((roundedScrollY - wrapperStartY) / pageHeight) + 1,
    1
  );
}
